export default __webpack_public_path__ + "static/media/1.84c33aa3.jpg";